import createMultiSelectionContext from '@/ui/contexts/MultiSelectionContext'
import { FileRequestToUpload } from '@/ui/hooks/useFileUpload'

export const { MultiSelectionProvider, useMultiSelectionContext } =
  createMultiSelectionContext<string, FileRequestToUpload>()
